import React from "react";

import { SelectInput } from "components/SelectInput";
import { TextInput } from "components/TextInput";
import {
	BENEFIT_STATUS_OPTIONS,
	PARTNER_OPTIONS
} from "../../constants";

import {
	ActionsRow,
	ApplyButton,
	ClearButton,
	FieldsRow,
	FilterBody,
	FilterCard,
	FilterSubtitle,
	FilterTitle
} from "./styles";

const Filters = ({
	filters,
	onChange,
	onApply,
	onClear,
	loading = false
}) => {
	const change = field => event => onChange(field, event.target.value);

	const handleSubmit = event => {
		event.preventDefault();
		onApply();
	};

	return (
		<FilterCard as="form" onSubmit={handleSubmit}>
			<FilterTitle>Filtro</FilterTitle>

			<FilterBody>
				<FilterSubtitle>Informações</FilterSubtitle>

				<FieldsRow>
					<TextInput
						label="Nome do prestador"
						placeholder="Por nome"
						value={filters.name}
						onChange={change("name")}
						disabled={loading}
					/>
					<TextInput
						label="CPF"
						placeholder="000.000.000-00"
						value={filters.cpf}
						onChange={change("cpf")}
						disabled={loading}
					/>
					<TextInput
						label="Empresa contratante"
						placeholder="Por nome"
						value={filters.company}
						onChange={change("company")}
						disabled={loading}
					/>
					<SelectInput
						label="Parceiro"
						options={PARTNER_OPTIONS}
						value={filters.partner}
						onChange={change("partner")}
						disabled={loading}
					/>
					<SelectInput
						label="Seguro de Vida"
						options={BENEFIT_STATUS_OPTIONS}
						value={filters.lifeInsuranceStatus}
						onChange={change("lifeInsuranceStatus")}
						disabled={loading}
					/>
					<SelectInput
						label="DIT"
						options={BENEFIT_STATUS_OPTIONS}
						value={filters.ditStatus}
						onChange={change("ditStatus")}
						disabled={loading}
					/>
				</FieldsRow>

				<ActionsRow>
					<ClearButton type="button" onClick={onClear} disabled={loading}>
						Limpar
					</ClearButton>
					<ApplyButton type="submit" disabled={loading}>
						Aplicar
					</ApplyButton>
				</ActionsRow>
			</FilterBody>
		</FilterCard>
	);
};

export default Filters;
